<template>
  <div class="failed-item">
    <div class="thumbnail">
      <div class="placeholder">
        <IconWrapper name="uploadVideoFailIcon" :icon-height="28" />
      </div>
    </div>
    <div class="info">
      <PanelItemTitle :title="video.title" :is-ai-video="isAiVideo" />
      <p class="error">
        {{ video.error || $t('video-processing-upload-fail') }}
      </p>
    </div>

    <div class="actions">
      <WithIconButton
        class="remove"
        :icon-name="'closeIconGray'"
        :variant="ButtonVariant.TERTIARY_GRAY"
        :size="ButtonSize.SMALL"
        :text="''"
        :icon-options="{ iconHeight: 14 }"
        :disable-hover="true"
        aria-label="Remove failed video"
        @click="$emit('remove')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRef } from 'vue'
import { IconWrapper, WithIconButton } from '@/components/common'
import { ButtonVariant, ButtonSize } from '@/styles/types'
import { ProcessingVideo } from '@/services/videos/types'
import { useProcessingPanelItem } from '@/composables/useProcessingPanelItem/useProcessingPanelItem'
import PanelItemTitle from './PanelItemTitle.vue'

const props = defineProps<{
  video: ProcessingVideo
}>()

const { isAiVideo } = useProcessingPanelItem(toRef(props, 'video'))

defineEmits<{
  (e: 'remove'): void
}>()
</script>

<style scoped lang="scss">
.failed-item {
  display: flex;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid $display-neutrals-300;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: $display-neutrals-100;
  }
}

.thumbnail {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 4px;
  background-color: $display-neutrals-100;
  border: 1px solid $display-neutrals-300;
  display: flex;
  align-items: center;
  justify-content: center;
}

.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.info {
  flex: 1;
  min-width: 0;
}

.error {
  font-size: 14px;
  color: $error-red-500;
  margin: 0;
  @include textTruncate(1);
}

.actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

</style>

